import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import SkipLink from '../components/SkipLink';
import Hero from '../components/Hero';
import Ticker from '../components/Ticker';
import Services from '../components/Services';
import HowWeWork from '../components/HowWeWork';
import FaqTeaser from '../components/FaqTeaser';
import About from '../components/About';
import Contact from '../components/Contact';
import Location from '../components/Location';
import Footer from '../components/Footer';
import Blog from '../components/Projects';
import WhyChooseUs from '../components/WhyChooseUs';
import Seo from '../components/Seo';
import { trackPageview, trackSections } from '../utils/analytics';

const HOME_TITLE = 'Visia Medical Group — юридичний супровід медичного бізнесу';
const HOME_DESCRIPTION =
  'Правовий супровід медичного бізнесу в Україні: реєстрація, ліцензування МОЗ, ЕСОЗ, документація, юридичний аутсорсинг. Від ідеї до успішної клініки.';

const Home = () => {
  const { hash } = useLocation();

  useEffect(() => {
    trackPageview();
    return trackSections();
  }, []);

  // Меню більше не користується якорями — кожен його пункт веде на окрему
  // сторінку. Але адреси на кшталт /#contact могли бути кимось збережені або
  // десь опубліковані, тож обробка лишається: браузер сам такий якір не
  // відпрацює, бо розмітка головної на момент навігації ще не змонтована.
  //
  // Прокрутка миттєва: плавна означала б, що людина, яка відкрила збережене
  // посилання на форму, кілька секунд дивиться, як повз неї пролітає весь сайт.
  useEffect(() => {
    if (!hash) return;
    const element = document.getElementById(hash.slice(1));
    if (!element) return;
    const id = window.requestAnimationFrame(() => {
      const y = element.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: y, behavior: 'auto' });
    });
    return () => window.cancelAnimationFrame(id);
  }, [hash]);

  return (
    <>
      <Seo title={HOME_TITLE} description={HOME_DESCRIPTION} path="/" />
      <SkipLink />
      <Navbar />
      <main id="content" tabIndex={-1} className="focus:outline-none">
        <Hero />
        {/*
          Склад головної.

          Головна довго була низкою білих екранів, що відрізнялися лише
          заголовками. Перша спроба це виправити чергувала білі секції з майже
          чорними — контраст вийшов завеликий. Тепер темного після першого
          екрана немає взагалі: секції чергують білий і світло-сірий тон, а
          зображення несуть фото — у «Про компанію», на картках послуг і в
          «Перевагах».

            hero          відео
            About         біла: фото, теза, абзац, чотири цінності рядком
            Ticker        світло-бірюзова стрічка тем — межа перед послугами
            Services      світло-сіра, шість карток із фото
            WhyChooseUs   біла, фотоплитка і п'ять плиток із малюнками
            HowWeWork     світло-сіра, п'ять кроків на дорозі
            FaqTeaser     бірюзова смуга: три питання перед блогом
            Blog          біла, дві колонки
            Contact       світло-сіра, біла форма
          Location      біла, Львів на карті
            Footer        білий

          «План запуску» і «Ліцензійна справа» з головної пішли: це подробиці
          однієї послуги, а не те, що потрібно кожному відвідувачу. План живе на
          /plan-zapusku-kliniky, склад ліцензійної справи — на сторінці послуги
          ліцензування. Шапка сама підлаштовується під тон блоку під нею
          (Navbar, data-tone) — тепер це лише відео й банери внутрішніх сторінок.
        */}
        <About />
        <Ticker />
        <Services />
        <WhyChooseUs />
        <HowWeWork />
        <FaqTeaser />
        <Blog />
        <Contact />
        <Location />
      </main>
      <Footer />
    </>
  );
};

export default Home;
